// @ts-ignore
import { elk } from '@tencent/ppd-base-libs';
/**
 * 微信 sdk 初始化
 * @param params
 * @returns
 */
const weiXinInit = async (params) => {
    const { enableReport, getTicket, apiList, openTagList } = params;
    const ticketInfo = await getTicket();
    const debug = window.location.href.indexOf('wxapidebug=1') > -1;
    return new Promise((resolve, reject) => {
        const beginTime = Date.now();
        enableReport && elk({
            key: 'JSApiInitBegin',
            num1: beginTime,
        });
        wx.config({
            debug,
            appId: ticketInfo.appId,
            timestamp: +ticketInfo.timestamp,
            nonceStr: ticketInfo.nonceStr,
            signature: ticketInfo.signature,
            jsApiList: apiList,
            openTagList, // 选填，需要用的openTagList
        });
        // 无论是否异常，都会调用ready，只不过异常时会先调用error后调ready
        // 如果异常，会掉调用error后reject出去，就不在会走到resolve的逻辑啦
        wx.ready(() => {
            console.log('wx sdk ready....');
            enableReport && elk({
                key: 'JSApiInitReady',
                num1: Date.now(),
                num2: Date.now() - beginTime,
            });
            resolve(true);
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
            // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，
            // 则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        });
        wx.error((res) => {
            console.error('wx sdk error....', res);
            enableReport && elk({
                key: 'JSApiInitError',
                str1: JSON.stringify(res),
                num1: Date.now(),
                num2: Date.now() - beginTime,
            });
            reject(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，
            // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
            // 对于SPA可以在这里更新签名。
        });
    });
};
export { weiXinInit, };
//# sourceMappingURL=base.js.map